module.exports = __webpack_public_path__ + "static/media/lamp1.1342ed5f.png";